module.exports = __webpack_public_path__ + "img/6.bcf42d11.png";